var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { apiCreateClientHotlineRequestContact } from '@/actions/ClientHotlineRequestActions';
import { CustomRedirect } from '@/components/functional/Link/CustomRedirect';
import Layout from '@/container/Layout';
import { usePrevPathContext } from '@/context/PrevPathContext';
import { HOTLINE_REQUEST_STATUS_SCHEDULING, HOTLINE_REQUEST_STATUS_SCHEDULED, } from '@/feature/hotline/client/constant/requestStatus';
import { useHotlineClientContactFormContext } from '@/feature/hotline/client/detail/contact/context/HotlineClientContactFormContext';
import { HotlineClientContactInputView } from '@/feature/hotline/client/detail/contact/input/page/HotlineClientContactInputView';
import { HotlineClientContactInputViewSkeleton } from '@/feature/hotline/client/detail/contact/input/page/HotlineClientContactInputViewSkeleton';
import { getHotlineClientRequestReorderSubmitValues } from '@/feature/hotline/client/detail/contact/util/getHotlineClientContactSubmitValues';
import { useHotlineClientDetailFetch } from '@/feature/hotline/client/detail/hook/useHotlineClientDetailFetch';
import { HotlineMeta } from '@/feature/hotline/component/HotlineMeta';
import { useNavigate } from '@/hooks/lib/react-router/useNavigate';
import { useParams } from '@/hooks/lib/react-router/useParams';
import { useUnmountRef } from '@/hooks/lifecycle/useUnmountRef';
import { wrapDispatch } from '@/utils/actions/dispatch';
import { pagePath } from '@/utils/router/pagePath';
/**
 * 匿名ホットライン今後の進め方 入力（ロジック部分のみ）
 */
export const HotlineClientContactInputPage = () => {
    const { id = '', requestId = '' } = useParams();
    const history = useNavigate();
    const dispatch = useDispatch();
    const unmountRef = useUnmountRef();
    // 「戻るボタン」のリンク取得
    const prevPath = usePrevPathContext();
    const { formValues, setFormValues } = useHotlineClientContactFormContext();
    // データ取得処理
    const { detailData, fetchDetailData, isLoading } = useHotlineClientDetailFetch({
        dispatch,
        id,
        unmountRef,
    });
    const detailOneData = detailData[id];
    const requestData = detailOneData === null || detailOneData === void 0 ? void 0 : detailOneData.hotline_requests.find((request) => request.id === parseInt(requestId, 10));
    // 詳細データ取得
    useEffect(() => {
        ;
        (() => __awaiter(void 0, void 0, void 0, function* () {
            if (!detailOneData) {
                yield fetchDetailData();
            }
        }))();
    }, [detailOneData, fetchDetailData]);
    const onSubmit = useCallback((formValue) => __awaiter(void 0, void 0, void 0, function* () {
        // バリデーションを実行
        yield wrapDispatch(dispatch, apiCreateClientHotlineRequestContact({
            json: getHotlineClientRequestReorderSubmitValues(formValue),
            path: { hotline_request_id: parseInt(requestId, 10), id },
        }, { isValidateOnly: true }));
        if (!unmountRef.current) {
            // state に保存
            setFormValues(formValue);
            // 送信後は確認画面へ遷移
            history.push(pagePath.hotline.client.contactConfirm(id, requestId));
        }
    }), [dispatch, id, requestId, history, setFormValues, unmountRef]);
    // ローディング中
    if (isLoading && !detailOneData) {
        return (_jsx(Layout, Object.assign({ mainClassName: 'l-main' }, { children: _jsx(HotlineClientContactInputViewSkeleton, {}) })));
    }
    // 詳細データが取得できなかった場合、相談一覧へリダイレクト
    if (!detailOneData) {
        return _jsx(CustomRedirect, { to: pagePath.mypage.client.hotline() });
    }
    // 申し込みデータが取得できなかった場合、相談詳細チャット画面にリダイレクト
    if (!requestData) {
        return _jsx(CustomRedirect, { to: pagePath.hotline.client.detailNegotiate(id) });
    }
    // 申し込みの状態が「調整中」または「相談予定」の場合、相談詳細チャット画面にリダイレクト
    if (requestData.status === HOTLINE_REQUEST_STATUS_SCHEDULING.value ||
        requestData.status === HOTLINE_REQUEST_STATUS_SCHEDULED.value) {
        return _jsx(CustomRedirect, { to: pagePath.hotline.client.detailNegotiate(id) });
    }
    return (_jsxs(_Fragment, { children: [_jsx(HotlineMeta, { relativePath: pagePath.hotline.client.contactInput(id, requestId), title: `${detailOneData.title} 今後の進め方を相談 - 入力 | PROFFIT` }), _jsx(Layout, Object.assign({ mainClassName: 'l-main' }, { children: _jsx(HotlineClientContactInputView, { defaultValues: formValues, id: id, onSubmit: onSubmit, prevLink: prevPath || pagePath.hotline.client.detailNegotiate(id), title: detailOneData.title }) }))] }));
};
